export default {
  // iconFolder: 'dist/assets/icons/', //dev
  iconFolder: 'assets/icons/', //prod
  devices: [
    {
      id: 1,
      name: 'Desktop',
      class: 'device-icon',
      resolution: '1536*864',
      icon: 'desktop.svg',
      scale: 0.5,
      tag: 'Desktop (1536 * 864)',
      'margin-top': ''
    },
    {
      id: 2,
      name: 'Tablet',
      class: 'device-icon',
      resolution: '1024*1366',
      icon: 'tablet.svg',
      scale: 0.55,
      tag: 'Tablet (1024 * 1366)',
      'margin-top': ''
    },
    {
      id: 3,
      name: 'Phone Landscape',
      class: 'device-icon',
      resolution: '736*414',
      icon: 'mobile_l.svg',
      scale: 0.85,
      tag: 'Mobile Landscape (736 * 414)',
      'margin-top': ''
    },
    {
      id: 4,
      name: 'Phone Portrait',
      class: 'device-icon',
      resolution: '414*736',
      icon: 'Mobile_p.svg',
      scale: 0.65,
      tag: 'Mobile Portrait (414 * 736)',
      'margin-top': ''
    }
  ],

  dummyCollection: [
    {
      id: 1,
      name: 'test1',
      group: '1',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTudREO8YtC5FYiNxrWseBC8EvjgHdBLw3dGoMzaB01JgTJ6qC-&s'
    },
    {
      id: 2,
      name: 'test2',
      group: '1',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9nDjUTDzm3wv3dVg6oBEP8yDJFYDWZm6gT__cSZQWoFweS5Qp&s'
    },
    {
      id: 3,
      name: 'test3',
      group: '1',
      image:
        'https://image.freepik.com/free-vector/modern-watercolor-colorful-headers-set-template-design_1035-14886.jpg'
    },
    {
      id: 4,
      name: 'test4',
      group: '1',
      image:
        'https://image.freepik.com/free-vector/modern-watercolor-colorful-headers-set-template-design_1035-14886.jpg'
    },
    {
      id: 5,
      name: 'test5',
      group: '1',
      image:
        'https://image.freepik.com/free-vector/modern-watercolor-colorful-headers-set-template-design_1035-14886.jpg'
    },
    {
      id: 6,
      name: 'test6',
      group: '1',
      image:
        'https://image.freepik.com/free-vector/modern-watercolor-colorful-headers-set-template-design_1035-14886.jpg'
    }
  ]
};
